import Dialog from 'sharedComponents/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React, { forwardRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Buttons';

const DeleteButtonBase = ({
  onClick,
  children,
  itemName = 'item',
  showIconButton,
  forwardedRef,
  title,
  description,
  confirmText,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  const toggle = event => {
    event.stopPropagation();
    setOpen(prevState => !prevState);
  };

  const onConfirm = event => {
    onClick();
    toggle(event);
  };
  return (
    <>
      {showIconButton ? (
        <IconButton ref={forwardedRef} onClick={toggle} size="large" {...rest}>
          {children}
        </IconButton>
      ) : (
        <Button color="error" onClick={toggle} {...rest}>
          {children || <FormattedMessage id="DeleteButton-label-delete" defaultMessage="Delete" />}
        </Button>
      )}
      <Dialog
        onClose={toggle}
        open={open}
        title={title || <FormattedMessage id="DeleteButton-dialog-title" defaultMessage="Confirm deletion" />}
        action={
          <Button color="error" variant="contained" onClick={onConfirm}>
            {confirmText || <FormattedMessage id="DeleteButton-label-delete" defaultMessage="Delete" />}
          </Button>
        }
      >
        <>
          {description ? (
            description
          ) : (
            <Typography variant="body1">
              <FormattedMessage
                id="DeleteButton-dialog-message"
                values={{ itemName }}
                defaultMessage="Are you sure you want to delete {itemName}?"
              />
            </Typography>
          )}
        </>
      </Dialog>
    </>
  );
};

const DeleteButton = forwardRef((props, ref) => <DeleteButtonBase {...props} forwardedRef={ref} />);

export default DeleteButton;
